import React from 'react';
import CheckInComponent from './CheckInComponent';

const Dashboard = () => {
  return (
    <div className="dashboard-content">
      <CheckInComponent />
    </div>
  );
};

export default Dashboard;